import { render, staticRenderFns } from "./view.vue?vue&type=template&id=1983a835&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1983a835')) {
      api.createRecord('1983a835', component.options)
    } else {
      api.reload('1983a835', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=1983a835&", function () {
      api.rerender('1983a835', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view.vue"
export default component.exports